export enum EnModal {
  AUTH = 'auth',
  ADULT = 'adult',
  EMAIL = 'email',
  DEPOSIT = 'deposit',
  SUBSCRIPTION = 'subscription',
  COMPLAIN = 'complain',
  COMMENT_COMPLAIN = 'comment_complain',
}
